import React, { useState } from 'react';
import BetStakeInput from '../../../BetStakeInput/BetStakeInput';
import { roundNumber } from '../../../../../utils/formatDecimal';
import { useEffectSkipFirst } from '../../../../../hooks/useEffectSkipFirst';
import { useDispatch } from 'react-redux';
import { changeBetLineStake } from '../../../../../store/actions/betSlip';
import { getTranslation } from '../../../../../utils/translation';
import styles from './BetStake.module.scss';

const BetStake = ({ bet }) => {
    const dispatch = useDispatch();

    const [stakeValue, setStakeValue] = useState(bet.stake);

    useEffectSkipFirst(() => {
        const betPayload = {
            eventId: bet.eventId,
            marketId: bet.marketId,
            outcomeId: bet.outcomeId,
            stake: stakeValue,
        };
        dispatch(changeBetLineStake(betPayload));
    }, [stakeValue]);

    return (
        <div className={styles.betAction}>
            <BetStakeInput
                betLine={bet}
                stake={stakeValue}
                setStakeValue={setStakeValue}
                inputWidth={'130px'}
                isLive={bet.isLive}
            />
            <div className={styles.earn}>
                <div className={styles.earnText}>{getTranslation('betSlip.betLine.return')}</div>
                <span className={styles.earnAmount}>{roundNumber(bet.stake * bet.odd, 2)}</span>
            </div>
        </div>
    );
};

export default BetStake;
